<template>
	<c-dialog ref="dialog" width="500" @resolve="transferHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="当前负责人">
				<c-input name="user_realname" disabled></c-input>
			</c-form-item>
			<c-form-item label="新负责人" required>
				<c-select name="new_user_id" async @search="searchScopeUser"></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'collabTaskTransfer',

		data() {
			return {

			}
		},

		methods: {
			/*********打开转移任务弹窗**********/
			open(data) {
				this._taskTypeId = data.task_type_id;

				this.$refs.form.clear();
				this.$refs.form.set({
					id: data.id,
					user_realname: data.user_realname
				});

				this.$refs.dialog.open({
					//标题过长截断，避免弹框标题溢出
					title: '转移任务【' + this.ellipsisTitle(data.task_title) + '】'
				});
			},

			/*******任务标题截断（超长显示省略号）*****************/
			ellipsisTitle(title) {
				title = title || '';
				return title.length > 12 ? title.slice(0, 12) + '...' : title;
			},

			/*******搜索新负责人（限任务类型的负责人范围内）*****************/
			searchScopeUser(keyword, resolve){
				this.request({
					url: '/collab/task/type/scope/users',
					data: {
						keyword: keyword,
						task_type_id: this._taskTypeId || ''
					},
					success: data => {
						resolve(data);
					}
				})
			},

			/*******转移任务提交处理方法********/
			transferHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: '/collab/task/transfer',
					rule: {
						new_user_id: '请选择新负责人'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '转移成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
